import {
  SEND_PDF_CSV_ADDRESS_PARSE, SEND_PDF_CSV_ADDRESS_PARSE_SUCCESS, SEND_PDF_CSV_ADDRESS_PARSE_FAILURE,
  SEND_PDF_ADDRESS_SEARCH, SEND_PDF_ADDRESS_SEARCH_SUCCESS, SEND_PDF_ADDRESS_SEARCH_FAILURE,
  SEND_PDF_ADDRESS_DELETE,
  SEND_PDF_ADDRESS_DELETE_ALL,
  SEND_PDF_UPLOAD_PDF_FILE, SEND_PDF_UPLOAD_PDF_FILE_SUCCESS, SEND_PDF_UPLOAD_PDF_FILE_FAILURE,
  SEND_PDF_SEND, SEND_PDF_SEND_SUCCESS, SEND_PDF_SEND_FAILURE, SEND_PDF_SEND_COMPLETED, SEND_PDF_SEND_CANCELED,
  SEND_PDF_FAX_STATUS_GET, SEND_PDF_FAX_STATUS_GET_SUCCESS, SEND_PDF_FAX_STATUS_GET_FAILURE,
  SEND_PDF_MSG_ALERT
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    notify: null,
    addresses: [],
    sendPdfNotifications: [],
    /** 送信宛先を追加 */
    addAddress: function (addresses) {
      var exists = this.addresses
      addresses.forEach(function (row) {
        var isSame = false
        var length = exists.length
        for (var i = 0; i < length; i++) {
          var compare = exists[i]
          // 重複は除外
          if (compare.name === row.name &&
              compare.fax.fax === row.fax.fax
              // compare.email.email === row.email.email
            ) {
            isSame = true
            break
          }
        }
        if (!isSame) {
          exists.push(row)
        }
      })
    },
    /** 通知を追加 */
    addNotification: function (hash) {
      var key = Math.floor(new Date().getTime())
      hash['key'] = key
      this.sendPdfNotifications.unshift(hash) // 先頭
      setTimeout(() => {
        this.deleteNotification(key)
      }, constant.notifyShowTime.normal)
    },
    /** 通知を削除 */
    deleteNotification: function (key) {
      var length = this.sendPdfNotifications.length
      for (var i = length - 1; i >= 0; i--) {
        var notification = this.sendPdfNotifications[i]
        if (notification.key === key) {
          this.sendPdfNotifications.splice(i, 1)
        }
      }
    }
  },
  getters: {
    addresses: state => {
      return state.addresses
    },
    sendPdfNotifications: state => {
      return state.sendPdfNotifications
    },
    sendPdfNotify: state => {
      return state.notify
    }
  },
  actions: {
    [SEND_PDF_CSV_ADDRESS_PARSE] ({dispatch, state, commit}, params) {
      var url = '/pdf_send/parse_csv'

      dispatch('apiPost', {url: url, data: params.data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SEND_PDF_CSV_ADDRESS_PARSE_FAILURE, res.data)
          } else {
            commit(SEND_PDF_CSV_ADDRESS_PARSE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SEND_PDF_ADDRESS_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/pdf_send/get_address'

      dispatch('apiGet', {url: url, data: params.data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SEND_PDF_ADDRESS_SEARCH_FAILURE, res.data)
          } else {
            commit(SEND_PDF_ADDRESS_SEARCH_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SEND_PDF_ADDRESS_DELETE] ({dispatch, state, commit}, params) {
      if (params.index != null) {
        var index = params.index
        if (index < state.addresses.length) {
          state.addresses.splice(index, 1)
        }
      }
    },
    [SEND_PDF_ADDRESS_DELETE_ALL] ({dispatch, state, commit}, params) {
      state.addresses = []
    },
    [SEND_PDF_UPLOAD_PDF_FILE] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var url = '/pdf_send/upload_pdf'

        dispatch('apiPost', {url: url, data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SEND_PDF_UPLOAD_PDF_FILE_FAILURE, res.data)
              reject()
            } else {
              commit(SEND_PDF_UPLOAD_PDF_FILE_SUCCESS, res.data)
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [SEND_PDF_SEND] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var url = '/pdf_send/send_pdf'

        dispatch('apiPost', {url: url, data: params.data, loadparams: false})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SEND_PDF_SEND_FAILURE, res.data)
              reject()
            } else {
              commit(SEND_PDF_SEND_SUCCESS, res.data)
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [SEND_PDF_SEND_COMPLETED] ({dispatch, state, commit}, params) {
      state.addNotification({
        success: true,
        message_i18n: 'send_pdf.completed'
      })
    },
    [SEND_PDF_SEND_CANCELED] ({dispatch, state, commit}, params) {
      state.addNotification({
        warning: true,
        message_i18n: 'send_pdf.canceled'
      })
    },
    [SEND_PDF_FAX_STATUS_GET] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var url = '/pdf_send/get_fax_send_status'

        dispatch('apiGet', {url: url, data: params.data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SEND_PDF_FAX_STATUS_GET_FAILURE, res.data)
              reject()
            } else {
              commit(SEND_PDF_FAX_STATUS_GET_SUCCESS, res.data)
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [SEND_PDF_MSG_ALERT] ({state, commit}, msg) {
      commit(SEND_PDF_MSG_ALERT, msg)
    }
  },
  mutations: {
    [SEND_PDF_ADDRESS_SEARCH_FAILURE] (state, data) {
      console.log('SEND_PDF_ADDRESS_SEARCH_FAILURE')
      if (data.error) {
        state.addNotification({
          danger: true,
          message_direct: data.error
        })
      }
    },
    [SEND_PDF_ADDRESS_SEARCH_SUCCESS] (state, data) {
      console.log('SEND_PDF_ADDRESS_SEARCH_SUCCESS')
      state.addAddress(data.addresses)
    },
    [SEND_PDF_CSV_ADDRESS_PARSE_FAILURE] (state, data) {
      console.log('SEND_PDF_CSV_ADDRESS_PARSE_FAILURE')
      if (data.error) {
        state.addNotification({
          danger: true,
          message_direct: data.error
        })
      }
    },
    [SEND_PDF_CSV_ADDRESS_PARSE_SUCCESS] (state, data) {
      console.log('SEND_PDF_CSV_ADDRESS_PARSE_SUCCESS')
      state.addAddress(data.addresses)
      state.addNotification({
        success: true,
        message_i18n: 'send_pdf.csv_parsed'
      })
    },
    [SEND_PDF_UPLOAD_PDF_FILE_FAILURE] (state, data) {
      console.log('SEND_PDF_UPLOAD_PDF_FILE_FAILURE')
      if (data.error) {
        state.addNotification({
          danger: true,
          message_direct: data.error
        })
      }
    },
    [SEND_PDF_UPLOAD_PDF_FILE_SUCCESS] (state, data) {
      console.log('SEND_PDF_UPLOAD_PDF_FILE_SUCCESS')
    },
    [SEND_PDF_SEND_FAILURE] (state, data) {
      console.log('SEND_PDF_SEND_FAILURE')
      if (data.error) {
        state.addNotification({
          danger: true,
          message_direct: data.error
        })
      }
    },
    [SEND_PDF_SEND_SUCCESS] (state, data) {
      console.log('SEND_PDF_SEND_SUCCESS')
    },
    [SEND_PDF_FAX_STATUS_GET_FAILURE] (state, data) {
      console.log('SEND_PDF_FAX_STATUS_GET_FAILURE')
      if (data.error) {
        state.addNotification({
          danger: true,
          message_direct: data.error
        })
      }
    },
    [SEND_PDF_FAX_STATUS_GET_SUCCESS] (state, data) {
      console.log('SEND_PDF_FAX_STATUS_GET_SUCCESS')
    },
    [SEND_PDF_MSG_ALERT] (state, msg) {
      state.notify = msg
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pdf-address.js